// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/expert_card/expertise_type.proto" (package "bianka.enums.expert_card", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.expert_card.ExpertiseType
 */
export enum ExpertiseType {
    /**
     * @generated from protobuf enum value: EXPERTISE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EXPERTISE_TYPE_LEAF_CAT_ID = 1;
     */
    LEAF_CAT_ID = 1,
    /**
     * @generated from protobuf enum value: EXPERTISE_TYPE_SKILL = 2;
     */
    SKILL = 2
}
